import React from 'react';

// Rendered when organization.active is false on the CA API. Mirrors ExpiredLink, but the cause is
// the org being switched off rather than a stale link, so the copy and the contact differ.
const FormClosed = ({ brand }) => {
  const companyName = brand?.companyName;
  const contact = brand?.contact;

  return (
    <div className="flex flex-col h-full items-center justify-center text-center px-6">
      <p className="mb-4 text-lg" style={{ color: '#083549' }}>
        This application form is no longer accepting submissions
      </p>
      <p className="mb-11" style={{ color: '#083549' }}>
        {companyName
          ? `${companyName} has closed this form.`
          : 'This form has been closed.'}
      </p>
      {contact ? (
        <>
          <p>If you need any information or help, please get in touch:</p>
          <p style={{ color: '#189DD6' }}>{contact}</p>
        </>
      ) : (
        <p>
          If you need any information or help, please check with the person who shared this form
          with you.
        </p>
      )}
    </div>
  );
};

export default FormClosed;
